import { JsonServiceClient } from "@servicestack/client";

export const DefaultClient = (baseUrl?: string, basePath?: string, theme?: string) => {
    const client = new JsonServiceClient(baseUrl).apply((c) => {
        c.basePath = basePath ?? null;
        c.headers = new Headers(); //avoid pre-flight CORS requests
    });

    client.exceptionFilter = (res: Response, error: any) => {
        if (res.status === 401 || error.responseStatus.message === "Unauthorized") {
            window.location.href = `/auth/openiddict?redirect=${encodeURIComponent(location.pathname + location.search)}&theme=${theme}`;
        } else if (res.status == 403 || res.status == 404) {
            window.location.href = "/error/" + res.status;
        }
    };

    return client;
};

export default DefaultClient;
